import CatalogsActionMenu from "./catalogsActionsMenu";

function getTableData(catalogs, setIsEditingCatalog, setCatalogToEdit) {
  //   return list of [    {
  // abbreviation: "AVI"
  // catalogTypeId: 2
  // id: 12
  // name: "AVICULTURA"
  // }]
  let _rows = [];
  catalogs.forEach((element, index) => {
    const row = {
      Nro: index + 1,
      Nombre: element.name,
      Abreviatura: element.abbreviation,
      Acciones: (
        <CatalogsActionMenu
          setIsEditingCatalog={setIsEditingCatalog}
          element={element}
          setElementToEdit={setCatalogToEdit}
        ></CatalogsActionMenu>
      ),
    };
    _rows.push(row);
  });

  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "10%" },
      { Header: "Nombre", accessor: "Nombre" },
      { Header: "Abreviatura", accessor: "Abreviatura" },
      { Header: "Acciones", accessor: "Acciones", width: "10%" },
    ],
    rows: _rows,
  };
}

export default getTableData;
